module.exports = __webpack_public_path__ + "static/media/book-spells.f5aeec12.svg";